import { createDecorator } from 'vue-class-component'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

const isPromise = function (obj: any) {
  return obj instanceof Promise || (obj && typeof obj.then === 'function')
}

export const Debounce = function (
  wait = 300,
  option: {
    leading?: boolean
    trailing?: boolean
  } = {
    leading: true,
    trailing: false,
  }
) {
  return createDecorator((options: any, key) => {
    const originalMethod = options.methods[key]
    options.methods[key] = debounce(originalMethod, wait, option)
  })
}

export const Throttle = function (
  wait = 300,
  option: {
    leading?: boolean
    trailing?: boolean
  } = {
    leading: true,
    trailing: false,
  }
) {
  return createDecorator((options: any, key) => {
    const originalMethod = options.methods[key]
    options.methods[key] = throttle(originalMethod, wait, option)
  })
}

export const Loading = function (loading = 'loading') {
  return function (target: Vue, key: string) {
    return createDecorator(function (componentOptions: any, key) {
      const originalMethod = componentOptions.methods[key]
      componentOptions.methods[key] = function (...args: any[]) {
        this.$data[loading] = true
        const returnValue = originalMethod.apply(this, args)
        if (isPromise(returnValue)) {
          returnValue.finally(() => {
            this.$data[loading] = false
          })
        } else {
          this.$data[loading] = false
        }
      }
    })(target, key)
  }
}

export const ValidateFormRule = function (formRef: string) {
  return function (target: Vue, key: string) {
    return createDecorator(function (componentOptions: any, key) {
      const originalMethod = componentOptions.methods[key]
      componentOptions.methods[key] = function (...args: any[]) {
        this.$refs[formRef].validate(async (valid: boolean) => {
          if (valid) {
            originalMethod.apply(this, args)
          }
        })
      }
    })(target, key)
  }
}

export const MessageDebug = function (info = 'todo：') {
  return createDecorator((options: any, key) => {
    const originalMethod = options.methods[key]
    options.methods[key] = async function (...args: any[]) {
      await this.$notify({
        title: `调用 ${key}`,
        dangerouslyUseHTMLString: true,
        message: `<h5>${info}</h5> <strong>${args
          .filter((item) => {
            return ['string', 'number', 'boolean', 'null', 'undefined'].includes(typeof item)
          })
          .join('-')} </strong>`,
        position: 'top-right',
        duration: 4 * 1000,
      })
      originalMethod.apply(this, args)
    }
  })
}

export const ToastDebug = function (info = 'todo：') {
  return createDecorator((options: any, key) => {
    const originalMethod = options.methods[key]
    options.methods[key] = async function (...args: any[]) {
      this.toast(`方法名：\n${key} ==> ${info}`)
      originalMethod.apply(this, args)
    }
  })
}
